<template>
  <div id="gwi-myPayDetail" class="app">
    <scroll class="scroll-height" @refresh="refresh">
      <section class="thick">
        <dl class="field">
          <dt>医院</dt>
          <dd>{{ hospitalName }}</dd>
        </dl>
        <dl class="field">
          <dt>科室/医生</dt>
          <dd>
            {{ param.queryParam.visitName
            }}<span v-if="param.queryParam.doctName"
              >/{{ param.queryParam.doctName }}</span
            >
          </dd>
        </dl>
        <dl class="field">
          <dt>姓名</dt>
          <dd>{{ param.queryParam.holderName }}</dd>
        </dl>
        <dl class="field">
          <dt>卡号</dt>
          <dd>
            {{ param.queryParam.cardType | cardType }}/{{
              param.queryParam.cardNo
            }}
          </dd>
        </dl>
        <dl class="field">
          <dt>订单号</dt>
          <dd>{{ param.queryParam.orderId }}</dd>
        </dl>
        <dl class="field">
          <dt>开单时间</dt>
          <dd>{{ param.queryParam.orderTime | formatpayDate }}</dd>
        </dl>
      </section>
      <div
        :id="'myPayDetail-payDetail-' + index"
        v-for="(item, index) in payDetailList"
        :key="index"
      >
        <section class="thick mythick">
          <div class="title" @click="showDetail(item)">
            <span class="f-strong">{{ item.recipeName }}</span>
            <div class="mytitle">
              <span class="f-strongest">{{ item.recipeFee | formatFee }}</span>
              <span v-show="!item.showDetailInfo" class="arr-gray-down"></span>
              <span v-show="item.showDetailInfo" class="arr-gray-up"></span>
            </div>
          </div>
          <div v-if="item.items.length > 0" v-show="item.showDetailInfo">
            <div
              v-for="subItem in item.items"
              :key="subItem"
              class="report-detail"
            >
              <div class="field myfield">
                <div>
                  <label>{{ subItem.itemName }}</label>
                </div>
              </div>
              <div class="report-table-container">
                <table class="report-table">
                  <tr>
                    <td class="f-minor">单价</td>
                    <td class="f-minor">数量</td>
                    <td class="f-minor">总价</td>
                  </tr>
                  <tr>
                    <td>{{ subItem.itemFee | formatFee(false) }}</td>
                    <td>{{ subItem.itemQty | formatItemQty }}</td>
                    <td>
                      {{ (subItem.itemFee * subItem.itemQty) | formatFee }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </scroll>
    <footer>
      <div v-if="!isPaySuccess" class="goPay">
        <span>总金额</span>
        <span class="f-strongest">{{ param.queryParam.fee | formatFee }}</span>
      </div>
      <button v-else class="btn-complete" type="button" @click="finished()">
        完成
      </button>
    </footer>
  </div>
</template>
<script>
export default {
  methods: {
    refresh () {
      this.messagePush();

      var postParam = this.param.queryParam;
      this.isClinicPay = this.param.isClinicPay;
      postParam.orderId = this.param.queryParam.orderId;

      var today = new Date();
      postParam.endDate = postParam.endDate || today.format('yyyy-MM-dd');
      today.setMonth(today.getMonth() - 3);
      postParam.startDate = postParam.startDate || today.format('yyyy-MM-dd');

      var url = '/app/clinic/paid/detail/{cardType}/{cardNo}/{startDate}/{endDate}/{orderId}';
      this.$http.get(url, {
        params: postParam
      }).then(res => {
        if (res.data.resultCode === this.constant.RESULT_SUCCESS) {
          var result = res.data.data;
          if (result.length > 0) {
            for (var i = 0; i < result.length; i++) {
              result[i].showDetailInfo = false;
            }
            this.payDetailList = result;
            this.hospitalName = result[0].hospitalName;
          }
        }
      });
    },
    showDetail (item) {
      item.showDetailInfo = !item.showDetailInfo;
    },
    messagePush () {
      var query = this.$router.currentRoute.query;
      //区分消息推送和正常页面跳转
      if (query.orderId) {
        //消息推送情况下，将需要的参数取下来保存至this.param.queryParam
        const geturlParam = {
          "visitName": query.visitName,
          "doctName": query.doctName,
          "holderName": query.holderName,
          "cardType": query.cardType,
          "cardNo": query.cardNo,
          "orderId": query.orderId,
          "orderTime": query.orderTime,
          "fee": query.fee,
        };
        this.param.queryParam = geturlParam;

        //设置医院消息头和localStorage
        const hospital = {
          "hospitalId": query.hospitalId,
          "hospitalIndex": query.hospitalIndex,
          "hospitalName": query.hospitalName,
          "hospitalType": query.hospitalType
        };
        localStorage.selectedHospital = JSON.stringify(hospital);
        http.headers.common['hospitalId'] = hospital.hospitalId;
      } else {
        this.param.queryParam = this.$store.state.paramModule.param.mypay.queryParam;
        this.isPaySuccess = this.$store.state.paramModule.param.mypay.isPaySuccess;
      }
    },
    finished: function () {
      this.$router.replace('/');
    }
  },
  data () {
    return {
      payDetailList: [/*{"orderId": "1110783", "recipeType": "30", "recipeName": "检查检验", "recipeFee": 6000, "hospitalId": "1001", "hospitalName": "佛山市第一人民医院", "cardType": "1", "cardNo": "7310001", "holderName": "张三", "showDetailInfo": false, "items": [{"itemName": "腹部B超", "itemFee": 4000, "itemQty": "1"}, {"itemName": "血常规7项", "itemFee": 2000, "itemQty": "1"}]}, {"orderId": "1110783", "recipeType": "10", "recipeName": "中药/西药", "recipeFee": 2800, "hospitalId": "1001", "hospitalName": "佛山市第一人民医院", "cardType": "1", "cardNo": "7310001", "holderName": "张三", "showDetailInfo": false, "items": [{"itemName": "阿西匹灵", "itemFee": 1000, "itemQty": "2"}, {"itemName": "阿莫西林克拉维酸钾", "itemFee": 400, "itemQty": "2"}]}*/],
      orderId: '',
      hospitalName: '',
      isClinicPay: false,
      param: {
        queryParam: {
          // "canPay": 1,
          // "cardNo": "510182198502280013",
          // "cardType": "4",
          // "deptName": "口腔科",
          // "doctName": "管理员",
          // "endDate": "2017/5/27 星期六 下午 3:14:00",
          // "fee": 1030000,
          // "holderName": "test3",
          // "orderType": 2,
          // "startDate": "2017/5/27 星期六 下午 3:14:00",
          // "visitId": "R0446922"
        }
      },
      isPaySuccess: false
    }
  },
  created () {
    this.refresh();
  }
}
</script>
<style lang="scss">
.scroll-height {
  margin-bottom: 1.8rem;
}
.mythick {
  margin-bottom: 0 !important;
}
.mytitle {
  float: right;
  padding-right: 1rem;
}
.myfield {
  background: #f8f8f8;
}
.goPay {
  height: 1.8rem;
  background-color: #fff;
  width: 100%;
  font-size: 0.9rem;
  line-height: 1.8rem;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// MypayDetail.vue?534fadf4